import { h } from 'vue';

// Utils
import { Text } from '@/utils';

// Mixinx
import { props, computed, methods } from './mixin';

export default {

    mixins: [props, computed, methods],

    render()
    {
        return h(
            'button',
            {
                class: [
                    this.classes,

                    this.divClass
                ],

                disabled: this.disabled || this.loading,

                onClick: () => this.onClick,
            },

            this.loading ?
                h(
                    'transition',
                    {
                        on:
                        {
                            name: 'fade',
                            mode: 'out-in',
                        },
                    },
                    [
                        h(
                            'i',
                            {
                                class: Text.joinClass(
                                    'fa',
                                    'fa-spinner',
                                    'fa-lg',
                                    'vh-animate',
                                    'vh-animate-infinite',
                                    'vh-animate-rotate'
                                ),
                            }
                        ),
                    ]
                )
                : this.$slots,
        );
    },
};
